module.exports = __webpack_public_path__ + "static/media/Slice19@2x.58fa8a16.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice19@2x.png
// module id = 1448
// module chunks = 0